import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  .bg-image {
    width: 100%;
    height: 100%;
    position: relative;

    .bg-image-rotate {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;

      .bg-image-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .overlay-gradient {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 31.53%, #000 100%);
      width: 100%;
      height: 70%;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
      display: block;
    }
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
    }

    .app-logo {
      margin: 0 0 30px;
    }
  }

  #root .ion-page & {
    ion-footer {
      padding: 16px 16px 32px;
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    margin: 0 0 20px;
    font-weight: 600;
  }
`;
